import { defineAsyncComponent } from 'vue'
export default {
  base: defineAsyncComponent(() => import("C:/Users/brend/GIT/kas-warranty/layouts/base.vue").then(m => m.default || m))
}